import { render } from "./KeyStats.vue?vue&type=template&id=30d4eca0"
import script from "./KeyStats.vue?vue&type=script&lang=js"
export * from "./KeyStats.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__